// classes
import SearchParams from "../classes/SearchParams";
import SearchPostsInDestinationParams from "../classes/SearchPostsInDestinationParams";

// Variables
import seasons from "../../core/variables/seasons.json";
import media from "../../core/variables/media.json";

const SEASONS = seasons;
const MEDIA = media;

export default {
  getSearchParams(searchParameters) {
    return new SearchParams(searchParameters);
  },
  newSearchParamsFromUrl(urlParams, username) {
    if (urlParams.seasons !== undefined) {
      Array.isArray(urlParams.seasons)
        ? (urlParams.seasons = this.hydrateSeasonItems(urlParams.seasons))
        : (urlParams.seasons = this.hydrateSeasonItems([urlParams.seasons]));
    }
    if (urlParams.media !== undefined) {
      Array.isArray(urlParams.media)
        ? (urlParams.media = this.hydrateMediaItems(urlParams.media))
        : (urlParams.media = this.hydrateMediaItems([urlParams.media]));
    }
    const themesbyCategory = JSON.parse(
      localStorage.getItem("themesByCategory")
    );
    themesbyCategory.forEach(category => {
      if (urlParams[category.nameEn] !== undefined) {
        Array.isArray(urlParams[category.nameEn])
          ? (urlParams[category.nameEn] = this.hydrateThemeCategoryItems(
              urlParams[category.nameEn],
              category.nameEn,
              themesbyCategory
            ))
          : (urlParams[category.nameEn] = this.hydrateThemeCategoryItems(
              [urlParams[category.nameEn]],
              category.nameEn,
              themesbyCategory
            ));
      }
    });
    return new SearchParams({ ...urlParams, username });
  },
  hydrateThemeCategoryItems(urlCategoryItems, category, themesbyCategory) {
    const seletedCategory = themesbyCategory.filter(
      item => item.nameEn == category
    )[0];
    let hydrateCategoryItems = [];
    urlCategoryItems.forEach(urlCategoryItem => {
      seletedCategory.themes.forEach(theme => {
        if (urlCategoryItem == theme.nameEn) {
          hydrateCategoryItems.push(theme);
        }
      });
    });
    return hydrateCategoryItems;
  },
  hydrateSeasonItems(urlSeasons) {
    let hydrateSeasonItems = [];
    urlSeasons.forEach(urlSeason => {
      SEASONS.forEach(season => {
        urlSeason === season.nameEn ? hydrateSeasonItems.push(season) : 0;
      });
    });
    return hydrateSeasonItems;
  },
  hydrateMediaItems(urlMedias) {
    let hydrateMediaItems = [];
    urlMedias.forEach(urlMedia => {
      MEDIA.forEach(media => {
        urlMedia === media.nameEn ? hydrateMediaItems.push(media) : 0;
      });
    });
    return hydrateMediaItems;
  },

  //
  // Search functions in Destination Page
  //
  getDestinationSearchParams(destinationSearchParams, destinationSearchId) {
    return new SearchPostsInDestinationParams({
      ...destinationSearchParams,
      destinationId: destinationSearchId
    });
  },
  // Build a new searchPostInDestinationsParams instance
  getSearchPostsInDestinationParams(params, newParameter, destinationId) {
    let objectNewParameter = {};
    objectNewParameter[newParameter.parameter] = newParameter.value;
    if (typeof objectNewParameter.media === "string") {
      objectNewParameter.media = [objectNewParameter.media];
    }
    if (objectNewParameter.seasons !== undefined) {
      Array.isArray(objectNewParameter.seasons)
        ? (objectNewParameter.seasons = this.hydrateSeasonItems(
            objectNewParameter.seasons
          ))
        : (objectNewParameter.seasons = this.hydrateSeasonItems([
            objectNewParameter.seasons
          ]));
    }
    THEME_NAMES.forEach(themeName => {
      if (objectNewParameter[themeName] !== undefined) {
        Array.isArray(objectNewParameter[themeName])
          ? (objectNewParameter[themeName] = this.hydrateThemeCategoryItems(
              objectNewParameter[themeName],
              themeName
            ))
          : (objectNewParameter[themeName] = this.hydrateThemeCategoryItems(
              [objectNewParameter[themeName]],
              themeName
            ));
      }
    });
    return new SearchPostsInDestinationParams({
      ...params,
      ...objectNewParameter,
      page: 1,
      destinationId
    });
  },
  addSearchPostsInDestination(params) {
    return new SearchPostsInDestinationParams({
      ...params,
      page: params.page + 1
    });
  },
  addSuggestionSearchPostInDestination(params, excludeNameIds) {
    delete params.seasons;
    delete params.page;
    delete params.media;
    delete params.activities;
    delete params.ambiances;
    delete params.travellers;
    delete params.transports;
    return new SearchPostsInDestinationParams({ ...params, excludeNameIds });
  }
};
